import styled from 'styled-components'

export const BlackTile = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(137deg, #000 0%, #8c959c 100%);
`

export const WhiteTile = styled.div`
  background: linear-gradient(137deg, #fff 0%, #f5f5f5 100%);
  border-width: 1px;
  border-color: ${({ theme }) => theme.colors.GREY_90};
  border-radius: 8px;
  border-style: solid;
  box-sizing: border-box;
`

export const TerminalShell = styled.img`
  width: 264px;
  height: 480px;
`

export const CustomLogo = styled.img<{ hasRoundedCorners: boolean }>`
  height: auto;
  width: auto;
  max-width: 640px;
  max-height: 996px;
  transform: scale(0.25, 0.25);
  border-radius: ${({ hasRoundedCorners }) =>
    hasRoundedCorners ? '32px' : '0'};
`
